import Phaser from 'phaser';

export const createAvatar = (x, y, targetSize, image, depth=5, tint=undefined) => {
	const m = window.manager;

	var container = m.scene.add.container(x, y);
	const def = m.scene.add.sprite(0, 0, 'profile_default');
	def.setScale(targetSize / def.width);
	var me = m.scene.add.sprite(0, 0, image);
	me.setScale(targetSize / me.width);

	var shape = m.scene.make
		.graphics({ fillStyle: { color: 0x000000 }, add: false })
		.fillCircleShape(new Phaser.Geom.Circle(x, y, targetSize / 2.08));
	container.shape = shape;
	container.mask = new Phaser.Display.Masks.GeometryMask(m.scene, shape);

	//me.setDepth(depth);
	container.add([def, me]);
	m.scoreCardElements.push(def, me);
	var myRing = m.scene.add.sprite(me.x, me.y, 'common', 'portrait_ring.png');
	myRing.setScale(targetSize / myRing.width);
	container.add(myRing);
	m.scoreCardElements.push(myRing);
	//myRing.setDepth(depth);

	if(tint) {
		me.setTint(tint);
		myRing.setTint(tint);
	}

	m.scoreCardElements.push(container);
	container.setDepth(depth);
	return container;
}

export const createPlateWithName = (_x, _y, _text, _size, _weight = 500, _scale = 1) => {
	const txt = addNameText(_x, _y, _text, _size, _weight, 1);
	const plateHeight = txt.height + 2 * _scale;
	const plates= namePlates(
		txt.x - txt.displayWidth / 2,
		txt.y - plateHeight / 2,
		txt.displayWidth,
		plateHeight,
		10, 0xfd963e, 1, 0xb6541f, 5
	);
	return {text: txt, plate: plates[0], plateShadow: plates[1]}
}

const addNameText = (x, y, text, size, weight = 500, alpha = 0) => {
	const m = window.manager;
	const txt = m.scene.add.text(x, y, text, {
		font: weight + ' ' + size + 'px ' + m.ui.dodFontFamily,
		fill: '#ffffff',
		stroke: '#cb651d',
		strokeThickness: 3,	
		shadow: { offsetX: 0, offsetY: 3, color: '#8f3a0e', blur: 0, stroke: false, fill: true },
	});
	txt.setOrigin(0.5, 0.5);
	txt.setDepth(6);
	txt.setAlpha(alpha);
	m.scoreCardElements.push(txt);	
	return txt;			
}
export const namePlates = (x, y, width, height, radius, color, alpha, dropShadow = 0x0, depth = 0, container = null) => {
	// return;
	const m = window.manager;
	var shadow = null;
	if (dropShadow > 0) {
		shadow = m.scene.add.graphics();
		shadow.lineStyle(1, dropShadow, alpha);
		shadow.fillStyle(dropShadow, alpha);
		shadow.fillRoundedRect(x, y + 8, width, height, radius);
		if (depth > 0) shadow.setDepth(depth);
		if (container != null) container.add(shadow);
		m.scoreCardElements.push(shadow);
	}
	var graphics = m.scene.add.graphics();
	graphics.lineStyle(1, color, alpha);
	graphics.fillStyle(color, alpha);
	graphics.fillRoundedRect(x, y, width, height, radius);
	if (depth > 0) graphics.setDepth(depth);
	if (container != null) container.add(graphics);
	m.scoreCardElements.push(graphics);
	m.ui.lastPlate = graphics;
	return [graphics, shadow];
}

export const avaLevelStar = (profilePic, targetSize, level) => {
	const m = window.manager;
	var container = m.scene.add.container(profilePic.x, profilePic.y);

	var adjustScale = targetSize / (158.175 * m.scaleFactor);
	var adjust = 1.0;
	if (adjustScale < 0.65) {
		adjustScale = 0.65;
		adjust = 1.6;
	}

	let star = m.scene.add.image(targetSize * (0.4 * adjust), targetSize * 0.3, 'common', 'levelUp_star.png'); //(myRing.width/2*myRing.scaleX), (myRing.height/2*myRing.scaleY)
	star.setOrigin(0.5, 0.5);
	star.setScale(0.75 * m.scaleFactor);
	star.setDepth(6);
	container.add(star);
	m.scoreCardElements.push(star);

	let levelText = m.scene.add.text(
		star.x + 0.075 * star.width, 
		star.y + 0.1 * star.width, 
		level, {
		fontFamily: m.ui.dodFontFamily,
		fontSize: '64px',
		fill: '#6a2c00',
		shadow: { offsetX: 0, offsetY: 2, color: '#ffffb9', blur: 0, stroke: false, fill: true },
	});

	levelText.setOrigin(0.5, 0.5);
	levelText.setDepth(6);
	container.add(levelText);
	m.scoreCardElements.push(levelText);

	container.setScale(0.85 * adjustScale);

	m.scoreCardElements.push(container);
	container.setDepth(6);
	return container;
}

export 	const createCircleAvatar = (x, y, size, image, name, level = -1) => {
	const _scene = window.manager.scene;
	const avatar = _scene.add.sprite(x, y, image);
	avatar.setScale(size / avatar.width);

	const ring = _scene.add.sprite(x, y, 'common', 'portrait_ring.png')
	ring.setScale(size / ring.width);
	updateMasks([avatar], size);

	const {text, plate, plateShadow} = createPlateWithName(0, 0, '  ' + name + '  ', 50);
	const plateCont = _scene.add.container(x, y+size/2, [plateShadow, plate, text]);

	const star = level > 0 ? avaLevelStar(avatar, size, level) : null;

	return level > 0 ? {avatar, ring, plateCont, star} : {avatar, ring, plateCont}
}
export const updateMasks = (images, size) => {
	images.forEach(img => {
		const rect = img.getBounds();
		const shape = window.manager.scene.make.graphics()
			.fillCircle(rect.centerX, rect.centerY, 0.95 *size /2);
		const geomMask = shape.createGeometryMask();
		img.setMask(geomMask);
	})
}

export const shadowTextStyle = (weight=700, fs=65) => ({
	font: weight + ' ' + fs +'px ' + window.manager.ui.dodFontFamily,
	fill: '#ffffff',  stroke: '#ff0000', strokeThickness: 0,
	shadow: { offsetX: 0, offsetY: 3, color: '#00000059', blur: 0, stroke: false, fill: true }
})
export const strokeTextStyle = (weight, fs) => ({
	font: weight + ' ' + fs +'px ' + window.manager.ui.dodFontFamily,
	fill: '#ffffff', stroke: '#6e2411', strokeThickness: 3,
	shadow: { offsetX: 0, offsetY: 3, color: '#00000059', blur: 0, stroke: false, fill: true }
})
